var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _currentMode, _updateCharacterCountBound, _displayCartErrorBound, _cartAddEventBound, _GiftCardRecipientForm_instances, inputFields_get, initializeForm_fn, updateFormState_fn, updateButtonStates_fn, clearRecipientFields_fn, disableRecipientFields_fn, enableRecipientFields_fn, updateCharacterCount_fn, setDateConstraints_fn, displayCartError_fn, displayErrorMessage_fn, clearErrorMessages_fn, handleCartAdd_fn;
import { Component } from "@theme/component";
import { StandardEvents, CartErrorEvent, CartLinesUpdateEvent } from "@shopify/events";
const _GiftCardRecipientForm = class _GiftCardRecipientForm extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _GiftCardRecipientForm_instances);
    __privateAdd(this, _currentMode, _GiftCardRecipientForm.DeliveryMode.SELF);
    // Store bound event handlers for cleanup
    /** @type {(() => void) | null} */
    __privateAdd(this, _updateCharacterCountBound, null);
    /** @type {((event: CartErrorEvent) => void) | null} */
    __privateAdd(this, _displayCartErrorBound, null);
    /** @type {((event: CartLinesUpdateEvent) => void) | null} */
    __privateAdd(this, _cartAddEventBound, null);
    __publicField(this, "requiredRefs", [
      "myEmailButton",
      "recipientEmailButton",
      "recipientFields",
      "recipientEmail",
      "recipientName",
      "recipientMessage",
      "recipientSendOn"
    ]);
  }
  connectedCallback() {
    super.connectedCallback();
    __privateMethod(this, _GiftCardRecipientForm_instances, initializeForm_fn).call(this);
    __privateSet(this, _updateCharacterCountBound, () => __privateMethod(this, _GiftCardRecipientForm_instances, updateCharacterCount_fn).call(this));
    this.refs.recipientMessage.addEventListener("input", __privateGet(this, _updateCharacterCountBound));
    __privateSet(this, _displayCartErrorBound, __privateMethod(this, _GiftCardRecipientForm_instances, displayCartError_fn).bind(this));
    document.addEventListener(StandardEvents.cartError, __privateGet(this, _displayCartErrorBound));
    __privateSet(this, _cartAddEventBound, (event) => __privateMethod(this, _GiftCardRecipientForm_instances, handleCartAdd_fn).call(this, event));
    document.addEventListener(StandardEvents.cartLinesUpdate, __privateGet(this, _cartAddEventBound));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (__privateGet(this, _updateCharacterCountBound)) {
      this.refs.recipientMessage.removeEventListener("input", __privateGet(this, _updateCharacterCountBound));
      __privateSet(this, _updateCharacterCountBound, null);
    }
    if (__privateGet(this, _displayCartErrorBound)) {
      document.removeEventListener(StandardEvents.cartError, __privateGet(this, _displayCartErrorBound));
      __privateSet(this, _displayCartErrorBound, null);
    }
    if (__privateGet(this, _cartAddEventBound)) {
      document.removeEventListener(StandardEvents.cartLinesUpdate, __privateGet(this, _cartAddEventBound));
      __privateSet(this, _cartAddEventBound, null);
    }
  }
  /**
   * Handle toggle between my email and recipient email
   * @param {string} mode - Delivery mode (either 'self' or 'recipient_form')
   * @param {Event} _event - Change event (unused)
   */
  toggleRecipientForm(mode, _event) {
    if (!Object.values(_GiftCardRecipientForm.DeliveryMode).includes(mode)) {
      throw new Error(
        "Invalid delivery mode: ".concat(mode, ". Must be one of: ").concat(Object.values(_GiftCardRecipientForm.DeliveryMode).join(
          ", "
        ))
      );
    }
    if (__privateGet(this, _currentMode) === mode) return;
    __privateSet(this, _currentMode, mode);
    __privateMethod(this, _GiftCardRecipientForm_instances, updateFormState_fn).call(this);
  }
};
_currentMode = new WeakMap();
_updateCharacterCountBound = new WeakMap();
_displayCartErrorBound = new WeakMap();
_cartAddEventBound = new WeakMap();
_GiftCardRecipientForm_instances = new WeakSet();
inputFields_get = function() {
  return [this.refs.recipientEmail, this.refs.recipientName, this.refs.recipientMessage, this.refs.recipientSendOn];
};
/**
 * Initialize form with default state, self delivery is selected by default
 */
initializeForm_fn = function() {
  __privateMethod(this, _GiftCardRecipientForm_instances, updateButtonStates_fn).call(this, _GiftCardRecipientForm.DeliveryMode.SELF);
  this.refs.recipientFields.hidden = true;
  __privateMethod(this, _GiftCardRecipientForm_instances, clearRecipientFields_fn).call(this);
  __privateMethod(this, _GiftCardRecipientForm_instances, disableRecipientFields_fn).call(this);
  __privateMethod(this, _GiftCardRecipientForm_instances, setDateConstraints_fn).call(this);
};
/**
 * Update form state based on current mode
 */
updateFormState_fn = function() {
  var _a, _b;
  const { DeliveryMode } = _GiftCardRecipientForm;
  const isRecipientMode = __privateGet(this, _currentMode) === DeliveryMode.RECIPIENT;
  __privateMethod(this, _GiftCardRecipientForm_instances, updateButtonStates_fn).call(this, __privateGet(this, _currentMode));
  this.refs.recipientFields.hidden = !isRecipientMode;
  if (isRecipientMode) {
    __privateMethod(this, _GiftCardRecipientForm_instances, enableRecipientFields_fn).call(this);
    __privateMethod(this, _GiftCardRecipientForm_instances, updateCharacterCount_fn).call(this);
    if (this.refs.liveRegion) {
      this.refs.liveRegion.textContent = ((_a = Theme.translations) == null ? void 0 : _a.recipient_form_fields_visible) || "Recipient form fields are now visible";
    }
    this.refs.recipientEmail.focus();
  } else {
    __privateMethod(this, _GiftCardRecipientForm_instances, clearRecipientFields_fn).call(this);
    __privateMethod(this, _GiftCardRecipientForm_instances, disableRecipientFields_fn).call(this);
    if (this.refs.liveRegion) {
      this.refs.liveRegion.textContent = ((_b = Theme.translations) == null ? void 0 : _b.recipient_form_fields_hidden) || "Recipient form fields are now hidden";
    }
  }
  this.dispatchEvent(
    new CustomEvent("recipient:toggle", {
      detail: {
        mode: __privateGet(this, _currentMode),
        recipientFormVisible: isRecipientMode
      },
      bubbles: true
    })
  );
};
/**
 * Update radio button states
 * @param {string} mode - Current delivery mode
 */
updateButtonStates_fn = function(mode) {
  const { DeliveryMode } = _GiftCardRecipientForm;
  switch (mode) {
    case DeliveryMode.SELF:
      this.refs.myEmailButton.checked = true;
      this.refs.recipientEmailButton.checked = false;
      break;
    case DeliveryMode.RECIPIENT:
      this.refs.myEmailButton.checked = false;
      this.refs.recipientEmailButton.checked = true;
      break;
    default:
      console.warn("Unknown delivery mode: ".concat(mode));
      this.refs.myEmailButton.checked = true;
      this.refs.recipientEmailButton.checked = false;
  }
};
/**
 * Clear all recipient form fields
 */
clearRecipientFields_fn = function() {
  for (const field of __privateGet(this, _GiftCardRecipientForm_instances, inputFields_get)) {
    field.value = "";
  }
  __privateMethod(this, _GiftCardRecipientForm_instances, updateCharacterCount_fn).call(this);
  __privateMethod(this, _GiftCardRecipientForm_instances, clearErrorMessages_fn).call(this);
};
/**
 * Disable recipient form fields when sending to self
 */
disableRecipientFields_fn = function() {
  for (const field of __privateGet(this, _GiftCardRecipientForm_instances, inputFields_get)) {
    field.disabled = true;
    field.removeAttribute("required");
    field.removeAttribute("aria-invalid");
    field.removeAttribute("aria-describedby");
  }
  const controlFlag = this.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]');
  if (controlFlag) {
    controlFlag.remove();
  }
  if (this.refs.timezoneOffset) {
    this.refs.timezoneOffset.disabled = true;
    this.refs.timezoneOffset.value = "";
  }
  __privateMethod(this, _GiftCardRecipientForm_instances, clearErrorMessages_fn).call(this);
};
/**
 * Enable recipient form fields when sending to recipient
 */
enableRecipientFields_fn = function() {
  for (const field of __privateGet(this, _GiftCardRecipientForm_instances, inputFields_get)) {
    field.disabled = false;
    if (field === this.refs.recipientEmail) {
      field.setAttribute("required", "required");
    }
  }
  let controlFlag = this.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]');
  if (!controlFlag) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[__shopify_send_gift_card_to_recipient]";
    input.value = "on";
    this.appendChild(input);
  }
  if (this.refs.timezoneOffset) {
    this.refs.timezoneOffset.disabled = false;
    this.refs.timezoneOffset.value = (/* @__PURE__ */ new Date()).getTimezoneOffset().toString();
  }
  __privateMethod(this, _GiftCardRecipientForm_instances, setDateConstraints_fn).call(this);
};
/**
 * Update character count display
 */
updateCharacterCount_fn = function() {
  if (!this.refs.characterCount) return;
  const currentLength = this.refs.recipientMessage.value.length;
  const maxLength = this.refs.recipientMessage.maxLength;
  const template = this.refs.characterCount.getAttribute("data-template");
  if (!template) return;
  const updatedText = template.replace("[current]", currentLength.toString()).replace("[max]", maxLength.toString());
  this.refs.characterCount.textContent = updatedText;
};
/**
 * Set date constraints for the send on date picker
 * Prevents selecting past dates and limits to 90 days in the future
 */
setDateConstraints_fn = function() {
  const today = /* @__PURE__ */ new Date();
  const maxDate = /* @__PURE__ */ new Date();
  maxDate.setDate(today.getDate() + 90);
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
  };
  this.refs.recipientSendOn.setAttribute("min", formatDate(today));
  this.refs.recipientSendOn.setAttribute("max", formatDate(maxDate));
};
/**
 * Handles cart error events
 * @param {import('@shopify/events').CartErrorEvent} event - The standardized cart error event
 */
displayCartError_fn = function(event) {
  const { error, code, detail } = event;
  if (code !== "INVALID") return;
  if ((detail == null ? void 0 : detail.errors) && typeof detail.errors === "object") {
    __privateMethod(this, _GiftCardRecipientForm_instances, displayErrorMessage_fn).call(this, error || "There was an error", detail.errors);
  } else if (error) {
    __privateMethod(this, _GiftCardRecipientForm_instances, displayErrorMessage_fn).call(this, error, {});
  }
};
/**
 * Display error messages in the appropriate error containers
 * @param {string} title - The main error message title
 * @param {Object} body - Error details
 */
displayErrorMessage_fn = function(title, body) {
  var _a;
  __privateMethod(this, _GiftCardRecipientForm_instances, clearErrorMessages_fn).call(this);
  if (typeof body === "object" && body !== null) {
    const fieldMap = {
      email: { inputRef: "recipientEmail", errorRef: "emailError" },
      name: { inputRef: "recipientName", errorRef: "nameError" },
      message: { inputRef: "recipientMessage", errorRef: "messageError" },
      send_on: { inputRef: "recipientSendOn", errorRef: "sendOnError" }
    };
    for (const [field, errorMessages] of Object.entries(body)) {
      const fieldConfig = fieldMap[field];
      if (!fieldConfig) continue;
      const { inputRef, errorRef } = fieldConfig;
      const errorContainer = this.refs[errorRef];
      const inputElement = this.refs[inputRef];
      if (errorContainer && errorContainer instanceof HTMLElement) {
        const errorTextElement = errorContainer.querySelector("span");
        if (errorTextElement) {
          const message = Array.isArray(errorMessages) ? errorMessages.join(", ") : errorMessages;
          errorTextElement.textContent = "".concat(message, ".");
        }
        errorContainer.classList.remove("hidden");
      }
      if (inputElement && inputElement instanceof HTMLElement) {
        inputElement.setAttribute("aria-invalid", "true");
        const errorId = "RecipientForm-".concat(field, "-error-").concat(this.dataset.sectionId || "default");
        inputElement.setAttribute("aria-describedby", errorId);
      }
    }
  }
  if (this.refs.liveRegion) {
    this.refs.liveRegion.textContent = title || ((_a = Theme.translations) == null ? void 0 : _a.recipient_form_error) || "There was an error with the form submission";
  }
};
/**
 * Clear all error messages and reset ARIA attributes
 */
clearErrorMessages_fn = function() {
  const errorRefs = ["emailError", "nameError", "messageError", "sendOnError"];
  for (const errorRef of errorRefs) {
    const errorContainer = this.refs[errorRef];
    if (errorContainer && errorContainer instanceof HTMLElement) {
      errorContainer.classList.add("hidden");
      const errorTextElement = errorContainer.querySelector("span");
      if (errorTextElement) {
        errorTextElement.textContent = "";
      }
    }
  }
  for (const field of __privateGet(this, _GiftCardRecipientForm_instances, inputFields_get)) {
    field.removeAttribute("aria-invalid");
    field.removeAttribute("aria-describedby");
  }
  if (this.refs.liveRegion) {
    this.refs.liveRegion.textContent = "";
  }
};
/**
 * @param {CartLinesUpdateEvent} event
 */
handleCartAdd_fn = function(event) {
  var _a;
  if (event.action !== "add") return;
  (_a = event.promise) == null ? void 0 : _a.then(() => __privateMethod(this, _GiftCardRecipientForm_instances, clearErrorMessages_fn).call(this)).catch(() => {
  });
};
__publicField(_GiftCardRecipientForm, "DeliveryMode", {
  SELF: "self",
  // Send to my email
  RECIPIENT: "recipient_form"
  // Send to recipient's email with form
});
let GiftCardRecipientForm = _GiftCardRecipientForm;
customElements.define("gift-card-recipient-form", GiftCardRecipientForm);
